<script setup lang="ts">
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import { Icons } from '@/models/icons.enum';
import { onMounted, ref } from 'vue';

const modalRef = ref<HTMLDialogElement | null>(null);

const emit = defineEmits<{
  close: [];
}>();

onMounted(() => {
  modalRef.value?.showModal();
});

function onOverlayClick() {
  emit('close');
}
</script>

<template>
  <Teleport to="body">
    <dialog
      class="excel-upload-modal"
      ref="modalRef"
      @click="onOverlayClick"
      data-cy="excel-upload-modal"
      @cancel.prevent="emit('close')">
      <div class="excel-upload-modal__container" @click.stop>
        <button class="excel-upload-modal__close" @click="emit('close')">
          <BackstageIcon :name="Icons.CROSS" class="excel-upload-modal__close-icon" />
        </button>
        <header class="excel-upload-modal__header"><slot name="header"></slot></header>
        <div class="excel-upload-modal__body"><slot name="main"></slot></div>
        <footer class="excel-upload-modal__footer"><slot name="footer"></slot></footer>
      </div>
    </dialog>
  </Teleport>
</template>

<style lang="scss" scoped>
.excel-upload-modal {
  padding: 0;
  border-radius: 12px;
  border: none;

  &__container {
    position: relative;
    padding: 64px 144px 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 24px;
    width: clamp(300px, 60vw, 824px);
  }

  &::backdrop {
    background-color: var(--transparent-black-50);
    backdrop-filter: blur(8px);
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 24px;
    border: none;
    background-color: transparent;
  }

  &__close-icon {
    padding: 12px;
    cursor: pointer;
  }

  &__header {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    align-items: start;
  }

  &__body {
    width: 100%;
  }

  &__footer {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    padding: 40px 0 64px;
  }
}
</style>
